import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import Modal from '@/components/shared/ModalV1/Modal.component';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { CarDetailsType } from '@/types';
import { TFunction } from 'i18next';
import { Dispatch, SetStateAction } from 'react';
import { CarDetailsHeader } from '../../../CarDetailsHeader/car-details-header';
import { PriceBreakDownDetails } from './price-breakdown-details';
import { PriceBreakDownCarIncludes } from './price-breakdown-car-includes';
import { SylndrHelpSectionModal } from '../../../SylndrHelpSection/sylndr-help-modal';

export const PriceBreakDownModal = ({
    openModal,
    setOpenModal,
    gradient,
    selectedCar,
    carType,
    t,
    lang,
}: {
    openModal: boolean;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
    gradient: string;
    selectedCar: CarDetailsType;
    carType: CarTypesEnum;
    t: TFunction;
    lang: AVAILABLE_LANGUAGES;
}) => {
    return (
        <Modal
            open={openModal}
            setOpen={setOpenModal}
            className="!rounded-xl w-[50%] !overflow-hidden"
            header={
                <CarDetailsHeader
                    title={t('CarProfile.PriceBreakDown.title')}
                    selectedCar={selectedCar}
                    carType={carType}
                />
            }
            style={{
                background: `linear-gradient(180deg, ${gradient} 0%, rgba(245, 254, 255, 0) 32%), #FFF`,
            }}
        >
            <div
                className={`h-full w-full flex flex-col relative
        `}
            >
                <div className="px-4">
                    <div className="grid grid-cols-2 gap-x-4 mb-6">
                        <PriceBreakDownDetails
                            carData={selectedCar}
                            carType={carType}
                            t={t}
                        />
                        <PriceBreakDownCarIncludes carType={carType} t={t} />
                    </div>
                    {carType === CarTypesEnum.Dealer && (
                        <SylndrHelpSectionModal lang={lang} />
                    )}
                </div>
            </div>
        </Modal>
    );
};
